module.exports = __webpack_public_path__ + "static/media/reels.a751dd0c.svg";